import {Box, Card, CardActionArea, CardContent, Divider, Grid, Typography} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React from "react";
import {CustomsRequirement} from "~/apps/packages/customs-requirements/queries";
import moment from "moment";
import {humanizeCustomsRequirementScreenType} from "~/apps/packages/customs-requirements/utils";
import {PortTheme} from "~/ui/theme";
import {StatusBadge} from "~/apps/core/ui/StatusBadge";
import { TypographyWithLabel } from "~/apps/core/ui/TypographyWithLabel";
import { formatDate } from "~/apps/core/utils";


export type CustomsRequirementItemProp = {
    customsRequirement: CustomsRequirement
}


const statusColorMap: {[key in CustomsRequirement["status"]]: string} = {
    "В работе": "#009ACF",
    "Завершен": "#28BA2C",
    "Отменен": "#B6BBC5",
}


const useStyles = makeStyles<PortTheme, CustomsRequirementItemProp>(theme => ({
    root: {
        width: "100%",
    },
}))


export function getCustomsRequirementItemHeight({customsRequirement}: CustomsRequirementItemProp) {
    if (customsRequirement.screeningType == "Физический") {
        return 239;
    }
    if (customsRequirement.screeningType == "МИДК") {
        return 195;
    }
    return 151;
}


export const CustomsRequirementItem = (props: CustomsRequirementItemProp) => {
    const classes = useStyles(props);
    const {customsRequirement} = props;
    return (
        <Card className={classes.root}>
            <CardContent>
                <Grid container direction="column" wrap="nowrap" rowSpacing="8px">
                    <Grid item container direction="column" rowSpacing="4px">
                        <Grid container direction="row" justifyContent="space-between">
                            <Grid item>
                                <StatusBadge variant="cardText" outlined={false} badgeColor={statusColorMap[customsRequirement.status]}>
                                    {customsRequirement.status}
                                </StatusBadge>
                            </Grid>
                            <Grid item>
                                <Typography variant="cardText">
                                    {formatDate(moment(customsRequirement.date, "YYYY-MM-DD"))}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Typography variant="cardTitle2" color="#232326">
                                {humanizeCustomsRequirementScreenType(customsRequirement.screeningType)}
                                {customsRequirement.screeningType == "Физический" && <>&nbsp;{customsRequirement.screeningDeep}%</>}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Divider/>
                    </Grid>
                    <Grid item>
                        <TypographyWithLabel label="КТК">
                            {customsRequirement.numberCTR}
                        </TypographyWithLabel>
                    </Grid>
                    {(customsRequirement.screeningType == "Физический" || customsRequirement.screeningType == "МИДК") && (
                        <Grid item>
                            <TypographyWithLabel label="Документ поступления">
                                {customsRequirement.billOfLanding || <>&mdash;</>}
                            </TypographyWithLabel>
                        </Grid>
                    )}
                    {customsRequirement.screeningType == "Физический" && (
                        <Grid item>
                            <TypographyWithLabel label="Дата досмотра">
                                {customsRequirement.screeningDate ? moment(customsRequirement.screeningDate, "YYYY-MM-DD").format("DD.MM.YYYY") : <>&mdash;</>}
                            </TypographyWithLabel>
                        </Grid>
                    )}
                    <Grid item>
                        <TypographyWithLabel label="Требование">
                            №{customsRequirement.number}
                        </TypographyWithLabel>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}